import BlockingScreenLayer from "../common/containers/BlockingScreenLayer"
import { FULLY_BLOCKING_POPUP_ZINDEX as zIndex } from "../../utils/constants/otherConstants";
import ConfirmPopup from "./ConfirmPopup";
import { useLogOut } from "../../hooks/authentication/useLogOut";

const LogoutConfirmPopup = ({show, setShow}) => {
    const onClickCancel = () => {
        setShow(false);
    }

    const onClickAccept = useLogOut();

    const buttons = [
        {
            onClick: onClickCancel,
            text: "Cancel"
        },
        {
            onClick: onClickAccept,
            text: "Accept"
        }
    ]

    return (
        <>
        {
            show &&
            <BlockingScreenLayer zIndex={zIndex}>
                <div className="full-width full-height d-flex flex-row jc-center ai-center">
                    <ConfirmPopup
                        title="Are you sure?"
                        message="You are about to logout and to be redirect to login page"
                        buttons={buttons}
                    />
                </div>
            </BlockingScreenLayer>
        }
        </>
    )
}

export default LogoutConfirmPopup;